import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import useColaboradorStore from "../stores/ColaboradorStore";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async criarHistorico(ordemDeServicoID = "", alteracaoDescricao = ""){

        const colaboradorStore = useColaboradorStore();
        let historicoOrdemDeServicoItem;

        try{

            //==================================================================//
            //=================== Pega Ordem de Serviço Item ===================//
            //==================================================================//

            let ordemDeServicoItem = await ERP.getOneById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoID);
            if(ordemDeServicoItem.status != 200){
                throw ordemDeServicoItem;
            }

            //==================================================================//
            //============ Prepara Historico X Ordem de Seviço Item ============//
            //==================================================================//

            let historicoOrdemDeServicoItemValores = {
                historicoResponsavel: colaboradorStore?.colaborador?.id || "",
                historicoDataCriacao: UtilDateTime.nowUTC(),
                historicoDescricao: alteracaoDescricao || "Item Alterado",
                ordemDeServicoItem: ordemDeServicoItem?.data?.id,
                ...ordemDeServicoItem.data
            };

            delete historicoOrdemDeServicoItemValores.id;

            //==================================================================//
            //============== Cria Historico Ordem de Serviço Item ==============//
            //==================================================================//

            historicoOrdemDeServicoItem = await ERP.postOne(Schema.HISTORICO_ORDEM_DE_SERVICO_ITEM, historicoOrdemDeServicoItemValores);
            if(historicoOrdemDeServicoItem.status != 200){
                throw historicoOrdemDeServicoItem;
            }

            console.log(historicoOrdemDeServicoItem);

        }catch(e){

            console.log(e);
            return historicoOrdemDeServicoItem;

        }

        return historicoOrdemDeServicoItem;

    },

    async criarHistoricos(ordemDeServicoItensIDs = [], alteracaoDescricao = ""){

        let historicoOrdemDeServicoItens;
        const colaboradorStore = useColaboradorStore();

        try{

            //==================================================================//
            //================= Pega Ordens de Serviço Itens ===================//
            //==================================================================//

            let ordemDeServicoItens = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS, ordemDeServicoItensIDs);
            if(ordemDeServicoItens.status != 200){
                throw ordemDeServicoItens;
            }

            //==================================================================//
            //============== Cria Historico Ordem de Seviço Itens ==============//
            //==================================================================//

            let historicoOrdemDeServicoItensValores = ordemDeServicoItens?.data?.map((ordemDeServicoItem)=>{

                let historicoOrdemDeServicoItemValores = {
                    historicoResponsavel: colaboradorStore?.colaborador?.id || "",
                    historicoDataCriacao: UtilDateTime.nowUTC(),
                    historicoDescricao: alteracaoDescricao || "Item Alterado",
                    ordemDeServicoItem: ordemDeServicoItem.id,
                    ...ordemDeServicoItem
                }

                delete historicoOrdemDeServicoItemValores.id;

                return historicoOrdemDeServicoItemValores;

            });

            //==================================================================//
            //============== Cria Historico Ordem de Serviço Item ==============//
            //==================================================================//

            historicoOrdemDeServicoItens = await ERP.postMany(Schema.HISTORICO_ORDEM_DE_SERVICO_ITEM, historicoOrdemDeServicoItensValores);
            if(historicoOrdemDeServicoItens.status != 200){
                throw historicoOrdemDeServicoItens;
            }

            console.log(historicoOrdemDeServicoItens);

        }catch(e){

            console.log(e);
            return historicoOrdemDeServicoItens;

        }

        return historicoOrdemDeServicoItens;

    }

}